import './src/styles/global.css'
import './src/styles/style.css'
import './src/styles/sommar.css'
import './src/styles/sommar_responsive.css'
import './src/styles/style-responsive.css'

import './src/styles/new-style.css'
import './src/styles/new-style-responsive.css'

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider